<template>
  <div class="configure-port-gpio">
    <div class="digital-inputs">
      <div v-for="(channel, channelNumber) in digitalInputs" style="position: relative; display: flex; flex-direction: column;">
        <button class="gpio-button"
          :disabled="isInputDisabled(channelNumber)"
          :class="gpiButtonClass(channelNumber)" 
          @click="toggleGpi(channelNumber)"
        >
          SDI-{{ portNumber * 24 + channelNumber + 1 }}
          <div v-for="control in getControls('gpi', portNumber, channelNumber)" style="font-size: smaller; font-family: consolas;">
            {{ controlLabel(control) }}
          </div>
        </button>
        <Checkbox v-if="ioMode == 3" binary style="position: absolute; margin-left: 3px;"
          :modelValue="channel.manualSelected.value"
          @click="toggleChannelManual(channel)"
        ></Checkbox>
      </div>
    </div>
    <div class="digital-outputs">
      <div v-for="(channel, channelNumber) in digitalOutputs" style="position: relative; display: flex; flex-direction: column;">
        <button class="gpio-button"
          :disabled="isOutputDisabled(channelNumber)"
          :class="gpoButtonClass(channelNumber)" 
          @click="toggleGpo(channelNumber)"
        >
          SDO-{{ portNumber * 24 + channelNumber + 1 }}
          <div v-for="control in getControls('gpo', portNumber, channelNumber)" style="font-size: smaller; font-family: consolas;">
            {{ controlLabel(control) }}
          </div>
        </button>
        <Checkbox v-if="ioMode == 3" binary style="position: absolute; margin-left: 3px;"
          :modelValue="channel.manualSelected.value"
          @click="toggleChannelManual(channel)"
        ></Checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import { createChannelMap, getControls, controlLabel } from "./appUtility.js";

export default {
  props: [
    "ioMode",
    "port",
    "portNumber"
  ],
  created() {
    this.digitalInputs = this.port.digitalInputs.children;
    this.digitalOutputs = this.port.digitalOutputs.children;
  },
  computed: {
    session() {
      return store.sessions[0];
    },
    channelMap() {
      return createChannelMap(store.sessions, this.session.system);
    }
  },
  methods: {
    isInputDisabled(channelNumber) {
      return (
        this.ioMode == 0 &&
        channelNumber >= this.port.channelCounts.value[1]
      );
    },
    isOutputDisabled(channelNumber) {
      return (
        (this.ioMode == 0 || this.ioMode == 2) && // auto or manual-inputs
        channelNumber >=  this.port.channelCounts.value[2] 
      );
    },
    getControls(controlType, portNumber, channelNumber) {
      return getControls(this.channelMap, controlType, "localhost", portNumber, channelNumber);
    },
    controlLabel(control) {
      return controlLabel(control);
    },
    toggleGpi(channelNumber) {
      this.session.queueRequest("/cmd/toggleGpi", {
        portNumber: this.portNumber,
        channelNumber: channelNumber
      });
      this.session.pollApp();
    },
    toggleGpo(channelNumber) {
      this.session.queueRequest("/cmd/toggleGpo", {
        portNumber: this.portNumber,
        channelNumber: channelNumber
      });
      this.session.pollApp();
    },
    toggleChannelManual(channel) {
      this.session.changeValues([{
        handle: channel.manualSelected.handle,
        value: !channel.manualSelected.value
      }]);
    },
    gpiButtonClass(channelNumber) {
      return {
        active: !this.port.digitalInputs.children[channelNumber].value.value
      }
    },
    gpoButtonClass(channelNumber) {
      return {
        active: this.port.digitalOutputs.children[channelNumber].value.value
      }
    }
  }
}
</script>

<style scoped>
.configure-port-gpio {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.digital-inputs,
.digital-outputs {
  flex-basis: 0;
  flex-grow: 1;
  padding: 10px;
  border: 1px solid gray;
  margin-top: -1px;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(8, minmax(0, 1fr));
  grid-template-rows: repeat(3, minmax(0, 1fr));
}
/* .digital-inputs {
  background: rgba(176, 196, 222, 0.281);
}
.digital-outputs {
  background: rgba(119, 136, 153, 0.281);
} */
.gpio-button {
  flex-grow: 1;
}
.gpio-button.active {
  color: white;
  font-weight: bold;
  background: limegreen;
}
.gpio-button:disabled:not(.active) {
  background: rgb(216, 216, 216);
}
.gpio-button.active:disabled {
  background: rgb(154, 192, 154);
}
</style>